import { render, staticRenderFns } from "./EditPartner.vue?vue&type=template&id=eb6b0654&scoped=true"
import script from "./EditPartner.vue?vue&type=script&lang=js"
export * from "./EditPartner.vue?vue&type=script&lang=js"
import style0 from "./EditPartner.vue?vue&type=style&index=0&id=eb6b0654&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eb6b0654",
  null
  
)

export default component.exports